export enum PRODUCT_SHOW_TYPE {
  GRID = 1,
  LIST = 2,
}
